var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from "react";
import styled from "styled-components";
import { classnames } from "../../utils";
import { Popover } from "../Popover";
var ModalStyle = styled(Popover)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: white;\n  border-radius: 3px;\n"], ["\n  background: white;\n  border-radius: 3px;\n"])));
var Modal = function (_a) {
    var id = _a.id, className = _a.className, style = _a.style, isOpen = _a.isOpen, closeOnEscape = _a.closeOnEscape, closeOnBackgroundClick = _a.closeOnBackgroundClick, onRequestClose = _a.onRequestClose, children = _a.children;
    return (React.createElement(ModalStyle, { isOpen: isOpen, onRequestClose: onRequestClose, closeOnEscape: closeOnEscape, closeOnBackgroundClick: closeOnBackgroundClick, placement: "center-screen", backdropStyle: {
            background: "rgb(0, 0, 0, 0.3)"
        }, id: id, className: classnames(className, "bn-dialog"), style: style }, children));
};
export default Modal;
var templateObject_1;
//# sourceMappingURL=Modal.js.map